<template>
  <div class="section pt-5">
    <branch-datatable ref="branch_datatable"></branch-datatable>
  </div>
</template>

<script>
import { get, error_message } from "@/utils";
import BranchDatatable from "./branch_datatable/Index.vue";

export default {
  name: "Branch",
  components: { BranchDatatable },
  data() {
    return {};
  },
  methods: {},
  mounted() {},
  created() {},
};
</script>

<style scoped></style>
